// REACT IMPORTS
import React, { useState } from "react";
import { Link } from "react-router-dom";

// STYLES
import "../Styles/Terms.css";

// COMPONENTS
import { ContactForm } from "../components/ContactForm";

export const PrivacyPolicy = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const logoUrl: string = "brand_marks/Augio_FullType_Logo_latest.png";

  return (
    <main className="terms-container">
      <Link className="terms-augio" to="/">
        AUGIO
      </Link>

      <div className="inner-text">
        <h1 className="terms-header">Augio Privacy Policy</h1>
        <h3 className="terms-subheader">Effective Date: June 9, 2026</h3>

        <h2 className="terms-subheader">Introduction</h2>
        <div className="terms-subtext">
          Augio, LLC ("Augio," "we," "our," or "us") respects your privacy and
          is committed to protecting your information. This Privacy Policy
          explains how we collect, use, disclose, and safeguard information when
          you access or use Augio, including our mobile applications, website,
          and related services (collectively, the "Service"). By using the
          Service, you agree to the collection and use of information as
          described in this Privacy Policy.
        </div>

        <h2 className="terms-subheader">Information We Collect</h2>

        <h3 className="member-terms-subheader">
          Information Collected Automatically
        </h3>
        <div className="terms-subtext">
          When you use the Service, we may automatically collect certain
          information, including:
        </div>
        <ul>
          <li className="terms-subtext">Device type and operating system</li>
          <li className="terms-subtext">App version</li>
          <li className="terms-subtext">General usage and interaction data</li>
          <li className="terms-subtext">
            Features accessed and content viewed
          </li>
          <li className="terms-subtext">
            Performance and diagnostic information
          </li>
          <li className="terms-subtext">Crash reports and error logs</li>
          <li className="terms-subtext">
            Push notification token, if notifications are enabled
          </li>
        </ul>
        <div className="terms-subtext">
          This information is generally collected through analytics,
          diagnostics, and platform monitoring tools.
        </div>

        <h3 className="member-terms-subheader">
          Information You Voluntarily Provide
        </h3>
        <div className="terms-subtext">
          We may collect information that you voluntarily submit through:
        </div>
        <ul>
          <li className="terms-subtext">Music submission forms</li>
          <li className="terms-subtext">Music recommendation forms</li>
          <li className="terms-subtext">Contact forms</li>
          <li className="terms-subtext">Customer support inquiries</li>
          <li className="terms-subtext">Surveys or feedback requests</li>
        </ul>
        <div className="terms-subtext">
          The information collected depends on the specific form or feature
          being used.
        </div>

        <h2 className="terms-subheader">How We Use Information</h2>
        <div className="terms-subtext">
          We may use information we collect to:
        </div>
        <ul>
          <li className="terms-subtext">Operate and maintain the Service</li>
          <li className="terms-subtext">
            Improve user experience and platform functionality
          </li>
          <li className="terms-subtext">Analyze usage trends and engagement</li>
          <li className="terms-subtext">Monitor performance and reliability</li>
          <li className="terms-subtext">Diagnose and fix technical issues</li>
          <li className="terms-subtext">Develop new features and services</li>
          <li className="terms-subtext">Deliver notifications and updates</li>
          <li className="terms-subtext">
            Protect the security and integrity of the Service
          </li>
          <li className="terms-subtext">Comply with legal obligations</li>
        </ul>

        <h2 className="terms-subheader">Analytics and Diagnostics</h2>
        <div className="terms-subtext">
          We use third-party analytics and diagnostic tools to better understand
          how users interact with the Service and to improve performance. These
          tools may collect information about app usage, device characteristics,
          performance metrics, and crash reports.
        </div>

        <h2 className="terms-subheader">Push Notifications</h2>
        <div className="terms-subtext">
          If you choose to enable notifications, we may use your device's
          notification token to deliver alerts, updates, and other
          communications related to the Service. You may disable notifications
          at any time through your device settings.
        </div>

        <h2 className="terms-subheader">Third-Party Services</h2>
        <div className="terms-subtext">
          The Service may utilize third-party service providers that assist us
          in operating, analyzing, and improving the Service. These providers
          may include:
        </div>
        <ul>
          <li className="terms-subtext">Sentry</li>
          <li className="terms-subtext">Amplitude</li>
          <li className="terms-subtext">Firebase</li>
        </ul>
        <div className="terms-subtext">
          These providers may collect, process, and store information in
          accordance with their own privacy policies. The Service may also
          contain links to third-party websites and streaming platforms. We are
          not responsible for the privacy practices or content of those
          third-party services.
        </div>

        <h2 className="terms-subheader">Data Retention</h2>
        <div className="terms-subtext">
          We retain information only for as long as reasonably necessary to
          operate, improve, and protect the Service, comply with legal
          obligations, resolve disputes, and enforce our agreements. Retention
          periods may vary depending on the type of information and applicable
          legal requirements.
        </div>

        <h2 className="terms-subheader">Data Security</h2>
        <div className="terms-subtext">
          We implement reasonable administrative, technical, and organizational
          safeguards designed to protect information from unauthorized access,
          disclosure, alteration, or destruction. However, no method of
          electronic transmission or storage is completely secure, and we cannot
          guarantee absolute security.
        </div>

        <h2 className="terms-subheader">Children's Privacy</h2>
        <div className="terms-subtext">
          The Service is not directed toward children under the age of 16. We do
          not knowingly collect personal information from children under 16. If
          we become aware that information has been collected from a child under
          16, we will take reasonable steps to remove it.
        </div>

        <h2 className="terms-subheader">Your Privacy Rights</h2>
        <div className="terms-subtext">
          Depending on your jurisdiction, you may have certain rights regarding
          information collected about you, including rights to access, correct,
          delete, or restrict the use of your information. To make a
          privacy-related request, please contact us using the information
          below.
        </div>

        <h2 className="terms-subheader">California Privacy Rights</h2>
        <div className="terms-subtext">
          California residents may have additional privacy rights under
          applicable California law. Requests regarding California privacy
          rights may be submitted{" "}
          <button
            onClick={() => setIsContactModalOpen(true)}
            style={{
              background: "none",
              border: "none",
              color: "inherit",
              textDecoration: "underline",
              cursor: "pointer",
              padding: 0,
              font: "inherit",
            }}
          >
            HERE
          </button>
        </div>

        <h2 className="terms-subheader">Changes to This Privacy Policy</h2>
        <div className="terms-subtext">
          We may update this Privacy Policy from time to time. Any updates will
          be posted with a revised Effective Date. Continued use of the Service
          after changes become effective constitutes acceptance of the updated
          Privacy Policy.
        </div>

        <h2 className="terms-subheader">Contact Us</h2>
        <div className="terms-subtext">
          If you have questions regarding this Privacy Policy or our privacy
          practices, please contact us{" "}
          <button
            onClick={() => setIsContactModalOpen(true)}
            style={{
              background: "none",
              border: "none",
              color: "inherit",
              textDecoration: "underline",
              cursor: "pointer",
              padding: 0,
              font: "inherit",
            }}
          >
            HERE
          </button>
        </div>

        <div
          className="terms-subtext"
          style={{ marginTop: "40px", opacity: 0.5 }}
        >
          © AUGIO 2026 All Rights Reserved
        </div>
      </div>
      <ContactForm
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
      />
    </main>
  );
};
